import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const TEXT = {
  hi: {
    msg: 'हम बेहतर अनुभव और विज्ञापनों के लिए कुकीज़ का उपयोग करते हैं। हमारी साइट का उपयोग जारी रखकर आप इससे सहमत होते हैं।',
    accept: 'स्वीकार करें',
    more: 'और जानें',
  },
  ur: {
    msg: 'ہم بہتر تجربے اور اشتہارات کے لیے کوکیز استعمال کرتے ہیں۔ ہماری سائٹ استعمال کر کے آپ اس سے متفق ہوتے ہیں۔',
    accept: 'قبول کریں',
    more: 'مزید جانیں',
  },
  en: {
    msg: 'We use cookies to enhance your experience and show relevant ads. By continuing to use our site, you agree to our use of cookies.',
    accept: 'Accept',
    more: 'Learn More',
  },
  es: {
    msg: '🍪 Usamos cookies para mejorar tu experiencia.',
    accept: 'Aceptar',
    more: 'Más info',
  },
  fr: {
    msg: '🍪 Nous utilisons des cookies pour améliorer votre expérience.',
    accept: 'Accepter',
    more: 'En savoir plus',
  },
};

const CookieConsent = () => {
  const { language } = useApp();
  const [visible, setVisible] = useState(false);
  const t = TEXT[language] || TEXT.en;

  useEffect(() => {
    const accepted = localStorage.getItem('cookie-consent');
    if (!accepted) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" dir={language === 'ur' ? 'rtl' : 'ltr'}>
      <p className="cookie-banner__text">{t.msg}</p>
      <div className="cookie-banner__actions">
        <Link to="/privacy-policy" className="cookie-banner__link">{t.more}</Link>
        <button className="cookie-banner__btn" onClick={handleAccept}>{t.accept}</button>
      </div>
    </div>
  );
};

export default CookieConsent;
